import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="28" viewBox="0 0 41 28">
    <g fill="none" fillRule="evenodd" strokeLinecap="square" stroke="#000" strokeWidth="2">
      <path d="M2 1L40 1M2 14L40 14M2 27L40 27" />
    </g>
  </svg>
);
